import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/brands-bg/johndoe_bg.png")